import { t } from '../translations/i18n'

import FileDetailsController from './file_details_controller'

export default class ChatFileDetailsController extends FileDetailsController {
  static targets = ['fileAttachmentContent', 'fileAttachmentLoading', 'fileAttachmentButton']

  render() {
    // If the file is still loading, we do not render anything
    if (this.decryptionStatus === 'loading') return

    this.fileAttachmentLoadingTarget.classList.add('hidden')
    const fileNameInnerHTML =
      this.decryptionStatus === 'success' ? this.fileName : t('common.cannot_be_decrypted')

    this.fileNameTarget.innerHTML = fileNameInnerHTML
    this.fileAttachmentContentTarget.classList.remove('hidden')
  }

  declare fileAttachmentContentTarget: HTMLDivElement
  declare fileAttachmentLoadingTarget: HTMLDivElement
  declare fileAttachmentButtonTarget: HTMLButtonElement
  declare fileNameTarget: HTMLSpanElement
}
